// extracted by mini-css-extract-plugin
export var inputTwoCol = "lead-form-module--input-two-col--AgJ7v";
export var leadForm = "lead-form-module--lead-form--n9y+n";
export var thankyouPage = "lead-form-module--thankyou-page--e2hhD";